export function secureListeners (passedListeners: Vue['$listeners']) {
    let pass = () => {};
    return {
        ...passedListeners,
        input: pass,
        value: pass,
        finished: pass,
        focus: pass,
        blur: pass,
    };
}
